import React from 'react'
import {FieldValues, useFormContext} from 'react-hook-form'

import type {Props} from './Form.types'

const noop = () => undefined

export function Form<FormValues extends FieldValues>({
  children,
  onSubmit = noop,
  onSubmitError,
  ...formProps
}: Props<FormValues>): React.ReactElement {
  const {handleSubmit} = useFormContext<FormValues>()

  return (
    <form onSubmit={handleSubmit(onSubmit, onSubmitError)} {...formProps}>
      {children}
    </form>
  )
}
